import React from 'react';
import PropTypes from 'prop-types';
import {isMobile} from '../utils/BrowserUtils';

export default class FbVideo extends React.Component {
  constructor() {
    super();

    this.state = {
      isIphone: false
    };

    this.videoPlayer = null;
    this.isClickedOnce = false;
  }

  componentDidMount() {
    this.setState({isIphone: isMobile.iPhone()}); //see VUP-308

    window.fbAsyncInit = () => {
      FB.init({
        xfbml: true,
        version: 'v2.5'
      });

      FB.Event.subscribe('xfbml.ready', (msg) => {
        if (msg.type === 'video') {
          this.videoPlayer = msg.instance;
          this.videoPlayer.subscribe('startedPlaying', this.onPlayerStarted.bind(this));
          this.videoPlayer.subscribe('paused', this.onPlayerPaused.bind(this));
        }
      });
    };

    this.initFbPlayer();
  }

  initFbPlayer() {
    ((d, s, id) => {
      let js,
fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        FB.init({
          xfbml: true,
          version: 'v2.5'
        });
      }
      js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  componentDidUpdate(prevProps) {
    const {url} = this.props;
    if (url && prevProps.url !== url) {
      this.initFbPlayer();
    }
  }

  onPlayerPaused() {
    this.isClickedOnce = true;
    this.onPlayerClick();
  }

  onPlayerStarted() {
    if (this.isClickedOnce) {
      this.onPlayerClick();
    }
  }

  onPlayerClick() {
    const {onPlayerClick} = this.props;
    onPlayerClick && onPlayerClick();
  }

  render() {
    const {url} = this.props;
    return (
      <div className="fb-video"
           data-href={url}
           data-allowfullscreen="true"
           data-autoplay={!this.state.isIphone} />
    );
  }
}

FbVideo.displayName = 'FbVideo';

FbVideo.propTypes = {
  url: PropTypes.string.isRequired,
  onPlayerClick: PropTypes.func
};

